import React, { useEffect, useState } from 'react';
import { getFullName, getInitials, getPhotoUrl } from '../utils/personUtils';

export default function Avatar({ person, name, size = 28 }) {
    const [imgError, setImgError] = useState(false);
    const displayName = getFullName(person) || name || '?';
    const photoUrl = getPhotoUrl(person?.photo);

    useEffect(() => {
        setImgError(false);
    }, [photoUrl]);

    const showPhoto = photoUrl && !imgError;
    return (
        <div
            className="flex items-center justify-center text-white font-bold flex-shrink-0 overflow-hidden"
            style={{
                width: size,
                height: size,
                borderRadius: '50%',
                fontSize: size < 28 ? 9 : 11,
                background: showPhoto ? 'transparent' : 'linear-gradient(90deg, #03488A 0%, #00AAF1 100%)',
            }}
            title={displayName}
        >
            {showPhoto ? (
                <img src={photoUrl} alt={displayName} className="w-full h-full object-cover" style={{ borderRadius: '50%' }} onError={() => setImgError(true)} />
            ) : getInitials(displayName)}
        </div>
    );
}
